module.exports = "<button [disabled]=\"shouldDisable()\" class=\"submit-btn feedback_box ml-15 mb40\" style=\"margin-top: 15px;\" (click)=\"onSubmitClick()\">\n  Submit\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/submit-button/submit-button.component.html
// module id = ./src/app/shared/components/submit-button/submit-button.component.html
// module chunks = main